import React from 'react';
import { pure, bemHelper } from '@dbk/ui-react-utils';
import {
  accordionBodyDefaultProps,
  accordionBodyPropTypes,
  renderComponent,
  BODY_TYPE,
} from './custom-accordion-common';

import styles from './custom-accordion.css';

const bem = bemHelper(styles, 'accordion');

const AccordionBody = ({ children }) => (
  <div className={bem('body')}>
    <div className={bem('content')}>
      {renderComponent(children, null, [], BODY_TYPE)}
    </div>
  </div>
);

AccordionBody.defaultProps = accordionBodyDefaultProps;
AccordionBody.propTypes = accordionBodyPropTypes;

export default pure(AccordionBody);
